import React from 'react'
import { Sidebar, Topbar } from '@/components/AccountShell'
import { useLang } from '@/lib/lang'

export default function Settings() {
  const { t } = useLang()
  const s = t.acct.settings

  const SECTIONS = [
    { label: s.language_label,  help: s.language_help,  action: s.language_action },
    { label: s.tz_label,        help: s.tz_help,        action: s.tz_action },
    { label: s.receipts_label,  help: s.receipts_help,  action: s.receipts_action },
    { label: s.connected_label, help: s.connected_help, action: s.connected_action },
    { label: s.twofa_label,     help: s.twofa_help,     action: s.twofa_action },
    { label: s.signout_label,   help: s.signout_help,   action: s.signout_action },
    { label: s.delete_label,    help: s.delete_help,    action: s.delete_action, danger: true },
  ]

  return (
    <div className="app-shell">
      <Sidebar />
      <div className="main-pane">
        <Topbar crumbs={[t.acct.nav.settings]} />
        <div className="content">
          <div className="kicker accent" style={{ marginBottom: 10 }}>{s.eyebrow}</div>
          <h1 className="h-display" style={{ fontSize: 36, margin: "0 0 24px" }}>
            {s.title_1} <span className="font-serif" style={{ color: "var(--terracotta)", fontWeight: 400 }}>{s.title_2_word}</span>
          </h1>
          <div className="tile" style={{ padding: 0, background: "var(--paper)", overflow: "hidden", maxWidth: 720 }}>
            {SECTIONS.map((sec, i) => (
              <div key={i} style={{ padding: "18px 22px", display: "grid", gridTemplateColumns: "1fr auto", gap: 16, alignItems: "center", borderTop: i ? "1px solid var(--line)" : "none" }}>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 2, color: sec.danger ? "var(--terracotta)" : "var(--cocoa)" }}>{sec.label}</div>
                  <div style={{ fontSize: 13, color: "var(--muted)" }}>{sec.help}</div>
                </div>
                <button className="btn" style={{ padding: "8px 14px", color: sec.danger ? "var(--terracotta)" : "var(--cocoa)" }}>{sec.action}</button>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  )
}
